export const environment = {
  production: false,
  API: "https://be.devel.tourismapp.it/",
  TREEQL: "https://be.devel.tourismapp.it/",
  IMAGES: "https://images.devel.tourismapp.it/",
  FILES: "https://files.devel.tourismapp.it/",
  MESSAGES: {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'danger',
    LOG: 'dark'
  },
  APP_LOGO: "/assets/logo.png",
  SUPERTOKENS: {
    ENABLE_DEBUG_MODE: true,
    APP_INFO: {
      APP_NAME: "Tourismapp",
      API_DOMAIN: "https://be.devel.tourismapp.it",
      API_BASE_PATH: "auth/",
      WEBSITE_DOMAIN: "https://biz.devel.tourismapp.it",
      WEBSITE_BASE_PATH: "auth",
    },
    CLIENT_TYPE: "tourimsmapp-web",
    RECIPE_LIST: {
      REDIRECT: {
        NEW_USER: "/home/account",
        EXISTING_USER: "/home",
        DEFAULT: "/home"
      }
    },
    STYLE: {
      PALETTE_PRIMARY: "110, 177, 85",
      PALETTE_PRIMARY_BORDER: "63, 120, 56",
    },
    LANGUAGE: {
      DEFAULT: "it",
    }
  },
SUPABASE: {
    URL: 'https://keenyityzekbesohhmad.supabase.co',
    ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtlZW55aXR5emVrYmVzb2hobWFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyNTU2NTIsImV4cCI6MjA1MzgzMTY1Mn0.S2jx0POE08K1VyT8iGOXkePet1tn2CD4x3Ouc83dGcA'
  },
  SUPABASE_STORAGE_BUCKET: {
    SHOPS: 'shops-media'
  }
};